// extracted by mini-css-extract-plugin
export default {"cell":"RelativeDateCell-cell-_hShQ TableRowCell-cell-giPrj"};